import React from 'react'
import Image from 'next/image'
import { friends } from '../../../assets'
import styles from './styles.module.css'

const ReverseImageTwo = () => {
  return (
    <div className={styles.reverseImagecontainer}>
      <div className={styles.bigImage}>
        <Image
          src={friends}
          alt='three friends looking at phone'
          width={590.5}
          height={514}
        />
      </div>
    </div>
  )
}

export default ReverseImageTwo
